"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slovenianTranslations = void 0;
var _types = require("../../../types");
const slovenianTranslations = exports.slovenianTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Tako mi je žal!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Nazaj',
  [_types.ErrorPageTranslationKey.text]: 'Ta stran trenutno ne deluje',
  [_types.ErrorPageTranslationKey.notFound]: 'Stran, ki jo iščete, ni na voljo',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stran, ki jo želite odpreti, je omejena in niso izpolnjena vsa merila.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Obrnite se na skupino za podporo Oriflame po e-pošti:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Zahtevani URL je bil zavrnjen!'
};
